import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import classnames from 'classnames';

import {
    Row, Col,
    Button,
    CardHeader,
    Card,
    CardBody,
    Progress,
    TabContent,
    TabPane,
    CardTitle,
    Table
} from 'reactstrap';

import BreadCrumb from '../../../api/helperComponents/BreadCrumb';
import { getDashboardReportAPI, getTodaysTreatmentAPI, getCenterInvoicesAPI } from './../../../api/network/Api';
import PageTitle from '../../../Layout/AppMain/PageTitle';

import axios from "axios";
import { toast, Bounce } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loader from '../../../api/helperComponents/Loader';
import { useHistory, useParams } from 'react-router-dom';
import Pagination from '../../../api/helperComponents/Pagination';

const CenterAdmin = () => {

    const history = useHistory()
    const cancelTokenSource = axios.CancelToken.source();
    const [dashboardTreatment, setDashboardTreatment] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [dashboardStats, setDashboardStats] = useState(null);
    const [centerInfo, setCenterInfo] = useState(null);
    const [role, setRole] = useState(JSON.parse(localStorage.getItem('userDetail'))?.role?.name);
    const [centerId, setCenterId] = useState(JSON.parse(localStorage.getItem('userDetail'))?.center_id);

    const [centerInvoices, setCenterInvoices] = useState([]);
    const [invoiceCount, setInvoiceCount] = useState(0);
    const [invoicePage, setInvoicePage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isInvoicesLoader, setIsInvoicesLoader] = useState(false);

    useEffect(() => {
        getDashboardReport()
        getTodaysTreatment()
        if (centerId) getCenterInvoices(centerId, invoicePage, rowsPerPage)
    }, []);
    useEffect(() => {
        if (localStorage.getItem('userDetail')) {
            if (JSON.parse(localStorage.getItem('userDetail'))) {
                let userDetail = JSON.parse(localStorage.getItem('userDetail'));
                if (userDetail) {
                    setCenterInfo(userDetail?.center_info)
                }
            }
        }
    }, []);

    useEffect(() => {
        if (centerId) getCenterInvoices(centerId, invoicePage, rowsPerPage)
    }, [invoicePage]);

    const getDashboardReport = async () => {
        setIsLoader(true)
        const response = await getDashboardReportAPI(cancelTokenSource.token)
        setIsLoader(false)
        if (response.success) {
            setDashboardStats(response?.data)
        } else {
            toast(response?.system_message, {
                transition: Bounce,
                closeButton: true,
                autoClose: 5000,
                position: 'bottom-center',
                type: 'error'
            });
        }
    }
    const getTodaysTreatment = async () => {
        setIsLoader(true)
        const response = await getTodaysTreatmentAPI(cancelTokenSource.token)
        setIsLoader(false)
        if (response.success) {
            setDashboardTreatment(response?.data?.rows)
        } else {
            toast(response?.system_message, {
                transition: Bounce,
                closeButton: true,
                autoClose: 5000,
                position: 'bottom-center',
                type: 'error'
            });
        }
    }

    const getCenterInvoices = async (cId, page, limit) => {
        setIsInvoicesLoader(true)
        const response = await getCenterInvoicesAPI(cId, page, limit, cancelTokenSource.token)
        setIsInvoicesLoader(false)
        if (response.success) {
            setCenterInvoices(response?.data?.rows || [])
            setInvoiceCount(response?.data?.count || 0)
        } else {
            toast(response?.system_message, {
                transition: Bounce,
                closeButton: true,
                autoClose: 5000,
                position: 'bottom-center',
                type: 'error'
            });
        }
    }

    const handleClickManageMembers = (e) => {
        history.push('/members')
    }
    const handleClickManageRoles = (e) => {
        history.push('/roles')
    }
    const handleInvoicePageChange = (newPage) => {
        setInvoicePage(newPage - 1);
    };

    return (
        <div>
            {(isLoader || isInvoicesLoader) && (<Loader />)}
            <BreadCrumb items={[
                { label: "Dashboard", url: "/" },
                { label: "Center List", url: "/centers" },
                { label: "Dashboard" },
            ]} />
            <Row>
                {role == "SUPER_ADMIN" && (
                    <Card className="main-card mb-3">
                        <CardTitle className="flex-space-between">Action Buttons</CardTitle>
                        <CardBody>
                            <div className="d-flex flex-wrap" style={{ gap: '10px' }}>
                                <button className="btn btn-primary" style={{ backgroundColor: '#47aaa8', borderColor: '#47aaa8' }} onClick={(e) => { handleClickManageMembers(e) }}>Manage Members</button>
                                <button className="btn btn-primary" style={{ backgroundColor: '#47aaa8', borderColor: '#47aaa8' }} onClick={(e) => { handleClickManageRoles(e) }}>Manage Roles</button>
                            </div>
                        </CardBody>
                    </Card>
                )}
                <Col md="3">
                    <div className="card mb-3 bg-arielle-smile widget-chart text-white card-border">
                        <div className="icon-wrapper rounded-circle">
                            <div className="icon-wrapper-bg bg-white opacity-10" />
                            <i className="lnr-cog icon-gradient bg-arielle-smile" />
                        </div>
                        <div className="widget-subheading" style={{ marginTop: '5px' }}>
                            Total Treatments
                        </div>
                        <div className="widget-description text-white">
                            <span className="ps-1 fs-32">{dashboardStats?.treatments}</span>
                        </div>
                    </div>
                </Col>
                <Col md="3">
                    <div className="card mb-3 bg-midnight-bloom widget-chart text-white card-border">
                        <div className="icon-wrapper rounded-circle">
                            <div className="icon-wrapper-bg bg-white opacity-10" />
                            <i className="lnr-cog icon-gradient bg-arielle-smile" />
                        </div>
                        <div className="widget-subheading" style={{ marginTop: '5px' }}>
                            Total Patients
                        </div>
                        <div className="widget-description text-white">
                            <span className="ps-1 fs-32">{dashboardStats?.patients}</span>
                        </div>
                    </div>
                </Col>
                <Col md="3">
                    <div className="card mb-3 bg-grow-early widget-chart text-white card-border">
                        <div className="widget-subheading" style={{ marginTop: '17px', marginBottom: '17px' }}>
                            <i className="fa fa-usd" />
                            <span style={{ marginLeft: '20px' }}>Treatments</span>
                        </div>
                        <div className="widget-description text-white" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <span className="ps-1">Treatments Bought: {centerInfo?.treatments_bought}</span>
                            <span className="ps-1">Treatments Refund: {centerInfo?.treatments_refund}</span>
                            <span className="ps-1">Treatments Used: {centerInfo?.treatments_used}</span>
                        </div>
                    </div>
                </Col>
                <Col md="3">
                    <div className="card mb-3 bg-love-kiss widget-chart card-border">
                        <div className="widget-subheading" style={{ marginTop: '10px' }}>
                            <i className="fa fa-users" />
                            <span style={{ marginLeft: '20px' }}>Total Members: <strong>{parseInt(dashboardStats?.accountants + dashboardStats?.consultantDoctors + dashboardStats?.staff + dashboardStats?.treatmentDoctors)}</strong></span>
                        </div>
                        <div className="widget-description text-white" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <span className="ps-1">Accountants: {dashboardStats?.accountants}</span>
                            <span className="ps-1">Consultant Doctors: {dashboardStats?.consultantDoctors}</span>
                            <span className="ps-1">Staff: {dashboardStats?.staff}</span>
                            <span className="ps-1">Treatment Doctors: {dashboardStats?.treatmentDoctors}</span>
                        </div>
                    </div>
                </Col>
            </Row>
            <Card className="main-card mb-3">
                <CardBody>
                    <CardTitle className="flex-space-between">Today's Treatment List</CardTitle>
                    <div class="table-responsive">
                        <Table striped className="mb-0">
                            <thead>
                                <tr>
                                    <th>Patient Name</th>
                                    <th>Center Name</th>
                                    <th>Treatment By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dashboardTreatment && dashboardTreatment.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item?.patient_info?.name}</td>
                                        <td>{item?.center_info?.name}</td>
                                        <td>{item?.user_created?.name}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </CardBody>
            </Card>

            <Card className="main-card mb-3">
                <CardBody>
                    <CardTitle className="flex-space-between">Today's Invoices</CardTitle>
                    <div class="table-responsive">
                        <Table striped className="mb-0">
                            <thead>
                                <tr>
                                    <th>Patient Name</th>
                                    <th>Date</th>
                                    <th>Amount</th>
                                    <th>Doctor</th>
                                    <th>Phone #</th>
                                    <th>Token Type</th>
                                    <th>Visit #</th>
                                    <th>Grand Total</th>
                                    <th>Payment Mode</th>
                                    <th>Payment Type</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {centerInvoices && centerInvoices.length > 0 ? (
                                    centerInvoices.map((inv, idx) => (
                                        <tr key={inv.id || idx}>
                                            <td>{inv?.token_info?.patient_info?.name}</td>
                                            <td>{inv?.invoice_date}</td>
                                            <td>{inv?.amount}</td>
                                            <td>{inv?.token_info?.doctor_info?.name}</td>
                                            <td>{inv?.token_info?.patient_info?.contact_number}</td>
                                            <td>{inv?.token_info?.token_type}</td>
                                            <td>{inv?.token_info?.token_number}</td>
                                            <td>{inv?.grand_total}</td>
                                            <td>{inv?.payment_mode}</td>
                                            <td>{inv?.payment_type}</td>
                                            <td>{inv?.status}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" className="text-center">No invoices found</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>

                    {invoiceCount > 10 && (
                        <Pagination
                            currentPage={invoicePage + 1}
                            totalPages={Math.ceil(invoiceCount / rowsPerPage)}
                            onPageChange={handleInvoicePageChange}
                        />
                    )}
                </CardBody>
            </Card>
        </div>
    );
}

export default CenterAdmin;
